export default {
  selectTypeRowInstructions: "Use SPACE to select a row.",
  emptyDataMessage: {
    title: "No data available.",
    body: ""
  }
};